import { render, staticRenderFns } from "./WriteOffRecord.vue?vue&type=template&id=d5070900&scoped=true&"
import script from "./WriteOffRecord.vue?vue&type=script&lang=js&"
export * from "./WriteOffRecord.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffRecord.vue?vue&type=style&index=0&id=d5070900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5070900",
  null
  
)

export default component.exports